import React from 'react';

export type UserTypeDetail = {
  isEasyPlanUser: boolean | undefined;
};

export const UserTypeContext = React.createContext<UserTypeDetail>({
  isEasyPlanUser: undefined,
});
